var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 3.33334H13.3333C6.66659 3.33334 3.33325 6.66668 3.33325 13.3333V21.6667C3.33325 30 6.66659 31.6667 13.3333 31.6667H14.1666C14.6166 31.6667 15.2333 31.9667 15.4999 32.3333L17.9999 35.6667C19.0999 37.1333 20.8999 37.1333 21.9999 35.6667L24.4999 32.3333C24.8166 31.9167 25.3166 31.6667 25.8333 31.6667H26.6666C33.3333 31.6667 36.6666 28.3333 36.6666 21.6667V15.8333",
    stroke: "#01C37D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.6667H28.3334",
    stroke: "#01C37D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 21.6667H21.6667",
    stroke: "#01C37D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 10.9722V6.80557M32.2223 14.4445V3.33334M29.4445 12.3611V5.41668M37.7779 6.80557V10.9722M35.0001 5.41668L35.0001 12.3611",
    stroke: "#01C37D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.58b07c382127f216fca3ec59d4d7ad84.svg";
export { ForwardRef as ReactComponent };